module.exports = __webpack_public_path__ + "static/img/loge.e702e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loge.png
// module id = rjdN
// module chunks = 1